import React, { useState } from 'react';
import UserIdentityService from '../../../core/services/UserIdentityService';
import Dropdown from '../../../core/components/Dropdown/Dropdown';
// @ts-ignore
import classNames from 'classnames';
import styles from './ProfileInfo.module.scss';

const ProfileInfo = () => {
    const userDetails = UserIdentityService.getUserDetails();
    const [isOpenDropdown, setIsOpenDropdown] = useState<boolean>(false);

    const handleOnClick = () => {
        setIsOpenDropdown(!isOpenDropdown);
    };

    return (
        <Dropdown isOpen={isOpenDropdown} classNames={styles.dropdownWrapper}>
            <>
                <Dropdown.Header classNames={styles.dropdownHeader}>
                    <>
                        <i className="fas fa-user" />
                        {userDetails.firstname} {userDetails.lastname}
                    </>
                </Dropdown.Header>

                <Dropdown.List classNames="c-dropdown-list">
                    <Dropdown.ListItem onClick={handleOnClick}>
                        <div className={styles.profileInfo}>
                            <ul className={classNames(
                                styles.profileInfoList,
                                styles['profileInfo__list--avatar']
                            )}>
                                {(userDetails.firstname && userDetails.lastname) && (
                                    <li>{userDetails.firstname} {userDetails.lastname}</li>
                                )}
                                <li>{userDetails.email}</li>
                                <li>Phone: {userDetails.phone}</li>
                            </ul>
                        </div>
                    </Dropdown.ListItem>
                    
                </Dropdown.List>
            </>
        </Dropdown>  
    )
}

export default React.memo(ProfileInfo);